module.exports = __webpack_public_path__ + "static/media/dj-tomiwa-white.32564d95.png";